import { useModelService } from 'services/model/model.service';
import { measureKpi, InfoDrawerKpiEntry } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';

function useMarketplaceNetSalesRatesKpis(): InfoDrawerKpiEntry[] {
  const { getMeasures } = useModelService();

  const measures = getMeasures([
    'netSlsGmvValRateExpOD',
    'slsGmvValOD',
    'slsNumOD',
    'retGmvValExpOD',
    'netSlsGmvValExpOD',
  ]);

  return measures.map(measure => measureKpi(measure));
}

export function MarketplaceNetSalesRatesInfoContent() {
  const kpis = useMarketplaceNetSalesRatesKpis();

  return (
    <InfoDrawerKpis.Default
      kpis={kpis}
      whyUsefulTitleId="info.content.why_is_it_useful"
      whyUsefulDescriptionId="insights.marketplace_tab.report.net_sales_rate.info.whyIsThisUseful"
      showOrderBasedNote
    >
      <hr className="my-4 border-snow-200" />
      <InfoContentItem
        titleId="info.content.data_availability"
        descriptionId="info.content.data_availability.description"
      />
    </InfoDrawerKpis.Default>
  );
}
